function publicAsset(path: string) {
  const base = import.meta.env.BASE_URL || '/';
  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  const normalizedPath = path.replace(/^\/+/, '');
  return `${normalizedBase}${normalizedPath}`;
}

export const BRAND_ASSETS = {
  colorLogo: publicAsset('assets/brand/zobu-logo-color.jpg'),
  whiteLogo: publicAsset('assets/brand/zobu-logo-white.png'),
} as const;

export const HERO_ASSETS = {
  homeMain: publicAsset('assets/photos/photo-03.jpg'),
  bannerInsight: publicAsset('assets/hero/banner-insight.jpg'),
  bannerNewYear: publicAsset('assets/hero/banner-newyear.jpg'),
  bannerExcellence: publicAsset('assets/hero/banner-excellence.jpg'),
  careerHero: publicAsset('assets/hero/career-hero.jpg'),
} as const;

export const SITE_PHOTOS = {
  photo01: publicAsset('assets/photos/photo-01.jpg'),
  photo02: publicAsset('assets/photos/photo-02.jpg'),
  photo03: publicAsset('assets/photos/photo-03.jpg'),
  photo04: publicAsset('assets/photos/photo-04.jpg'),
  photo05: publicAsset('assets/photos/photo-05.jpg'),
  photo06: publicAsset('assets/photos/photo-06.jpg'),
  photo07: publicAsset('assets/photos/photo-07.jpg'),
} as const;

export const REFERENCE_CLIENT_LOGOS = {
  ihkib: publicAsset('assets/logos/reference-clients/ihkib.jpg'),
  karaisali: publicAsset('assets/logos/reference-clients/karaisali.jpg'),
  izka: publicAsset('assets/logos/reference-clients/izka.jpg'),
  akib: publicAsset('assets/logos/reference-clients/akib.jpg'),
  bebka: publicAsset('assets/logos/reference-clients/bebka.jpg'),
  oka: publicAsset('assets/logos/reference-clients/oka.jpg'),
  tupras: publicAsset('assets/logos/reference-clients/tupras.jpg'),
  ifc: publicAsset('assets/logos/reference-clients/ifc.jpg'),
  izmirBb: publicAsset('assets/logos/reference-clients/izmir-bb.jpg'),
  ankaraka: publicAsset('assets/logos/reference-clients/ankaraka.jpg'),
  ahkTurkei: publicAsset('assets/logos/reference-clients/ahk-turkei.jpg'),
  greenAnatoliaEnergy: publicAsset('assets/logos/reference-clients/green-anatolia-energy.jpg'),
} as const;
